export default "__VITE_ASSET__EjkCCOLq__"